import * as d3 from 'd3'
import React, { Component } from 'react'
import * as topojson from 'topojson-client'
import map from '../maps/veneto_cpi.json'
import R from '../ramda'
import './Map.css'
import U from '../Utils'

class MapSaldo extends Component {
  constructor(props) {
    super(props)

    this.show_tooltip = this.show_tooltip.bind(this)
    this.hide_tooltip = this.hide_tooltip.bind(this)
  }

  shouldComponentUpdate() {
    return false
  }

  ref(name) {
    return (ref) => {
      this[name] = d3.select(ref)
    }
  }

  componentDidMount() {
    this.renderD3(this.props)
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.map_data !== this.props.map_data) {
      this.renderD3(nextProps)
    }
  }

  renderD3(props) {
    const { with_shadow, map_data, series, print } = props
    const MAX_R = 50
    const ANIM_FRAME = 2000,
      ANIM_TRANS = 500

    // indice serie corrente
    let cur_series = 0

    // inizializzazione cartina
    const cpi = topojson.feature(map, R.values(map.objects)[0]).features
    const path = d3.geoPath().projection(null)
    const path_trunc = (d) => path(d).replace(/\.\d+/g, '')

    // preparazione dei dati dalla query
    const data_map = new Map(map_data.map((row) => [row.id, row]))
    const cur_suf = () => series[cur_series].suf
    this.get_val = (d) => data_map.get(d.properties.id)['val' + cur_suf()] || 0
    this.get_label = () => `Saldo ${series[cur_series].name}`.trim()
    this.get_sel = (d) => data_map.get(d.properties.id).sel
    const cpi_sorted = R.sortBy(R.compose(R.negate, Math.abs, this.get_val))(cpi)
    const cpi_sel = cpi_sorted.filter(this.get_sel)
    const cpi_non = cpi_sorted.filter(R.compose(R.not, this.get_sel))
    const max_abs = map_data.reduce(
      (max, row) =>
        Math.max(
          max,
          series.reduce((max, { suf }) => Math.max(max, Math.abs(row['val' + suf])), 0),
        ),
      0,
    )

    // rendering confini
    const render_paths = (sel, data) => {
      const paths = sel.selectAll('path').data(data, (d) => d.properties.id)
      paths.enter().append('path').merge(paths).attr('d', path_trunc)
    }

    // rendering bolle con transizioni
    const radius = d3.scaleSqrt().domain([0, max_abs]).range([0, MAX_R])
    const render_bubbles = (sel, data) => {
      const paths = sel.selectAll('circle').data(data, (d) => d.properties.id)
      paths
        .enter()
        .append('circle')
        .attr('transform', (d) => `translate(${path.centroid(d)})`)
        .on('mouseover', this.show_tooltip)
        .on('mouseout', this.hide_tooltip)
        .merge(paths)
        .each((d, i, nodes) => {
          const sel = d3.select(nodes[i])
          const val = this.get_val(d)
          const old_neg = sel.classed('neg')
          const new_neg = val < 0
          const new_r = radius(Math.abs(val))
          const apply_neg_pos = () => sel.classed('neg', new_neg).classed('pos', !new_neg)
          if (print) {
            sel.attr('r', new_r)
            apply_neg_pos()
          } else if (old_neg !== new_neg) {
            sel
              .transition()
              .duration(ANIM_TRANS / 2)
              .attr('r', 0)
              .transition()
              .duration(ANIM_TRANS / 2)
              .on('start', apply_neg_pos)
              .attr('r', new_r)
          } else {
            sel.transition().duration(ANIM_TRANS).attr('r', new_r)
            apply_neg_pos()
          }
        })
    }

    // sfondo non selezionato
    this.svg.append('g').classed('sfondo non', true).call(render_paths, cpi_non)

    // bolle non selezionate
    const bubble_non = this.svg.append('g').classed('bubble non', true)

    // sfondo selezione, con ombra
    this.svg
      .append('g')
      .classed('sfondo sel', true)
      .style('filter', with_shadow ? 'url(#ombra)' : null)
      .call(render_paths, cpi_sel)

    // bolle selezione
    const bubble_sel = this.svg.append('g').classed('bubble sel', true)

    // rendering dei keyframe (serie 1, serie 2) durante l'animazione
    const keyframe = () => {
      bubble_non.call(render_bubbles, cpi_non)
      bubble_sel.call(render_bubbles, cpi_sel)
      this.series_label.text(series[cur_series].name)
      for (let el of [this.svg, this.series_label]) {
        el.classed('serie-A', series.length > 1 && cur_series === 0).classed(
          'serie-B',
          series.length > 1 && cur_series === 1,
        )
      }
    }

    // rendering iniziale
    keyframe()

    // animazione, se serie attive
    if (this.play_interval) clearInterval(this.play_interval)
    if (series.length > 1 && !print) {
      this.play_interval = setInterval(() => {
        if (this.pause_animation) return
        cur_series = (cur_series + 1) % series.length
        keyframe()
      }, ANIM_FRAME)
    }
  }

  show_tooltip(d) {
    this.pause_animation = true
    const elem = d3.event.target
    const sb = this.svg.node().getBoundingClientRect()
    const b = elem.getBoundingClientRect()
    const above = (b.top + b.height) / (sb.top + sb.height) > 0.9
    const x = b.left - sb.left + b.width / 2
    const y = b.top - sb.top + (above ? 0 : b.height)
    const name = d.properties.label
    const value = U.formatNumberPlus(this.get_val(d))
    this.tooltip
      .html(`<h5>${name}</h5><p>${this.get_label()}: <b>${value}</b></p>`)
      .classed('above', above)
      .style('opacity', 0.8)
      .style('left', `${x}px`)
      .style('top', `${y}px`)
  }

  hide_tooltip() {
    this.pause_animation = false
    this.tooltip.style('opacity', 0)
  }

  render() {
    const PAD = 40 // filter stdDeviation * 2 ??
    const [x, y, width, height] = map.bbox
    const viewBox = [x - PAD, y - PAD, width + PAD * 2, height + PAD * 2].join(' ')
    return (
      <div className="map">
        <div className="series" ref={this.ref('series_label')} />
        <svg className="map" viewBox={viewBox} ref={this.ref('svg')}>
          <filter id="ombra" x="-50%" y="-50%" width="200%" height="200%">
            <feOffset result="offOut" in="SourceAlpha" />
            <feGaussianBlur result="blurOut" in="offOut" stdDeviation="20" />
            <feBlend in="SourceGraphic" in2="blurOut" mode="normal" />
          </filter>
        </svg>
        <div className="tooltip" ref={this.ref('tooltip')} />
      </div>
    )
  }
}

export default MapSaldo



// WEBPACK FOOTER //
// ./src/main/MapSaldo.js